<template>
  <!-- 盒子管理-导出 -->
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="导出数据"
      width="350px"
      @close="closeDialog"
    >
      <el-form
        :model="formData"
        v-if="formData"
        ref="formData"
        label-width="80px"
        size="small"
        :rules="taskRules"
      >
        <el-form-item prop="box_id" label="盒子id">
          <el-input
            v-model="formData.box_id"
            placeholder="id需英文的逗号(,)隔开"
          ></el-input>
        </el-form-item>
        <el-form-item prop="start_time" label="开始时间">
          <el-date-picker
            v-model="formData.start_time"
            type="datetime"
            placeholder="开始时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="end_time" label="结束时间">
          <el-date-picker
            v-model="formData.end_time"
            type="datetime"
            placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="closeDialog">取消</el-button>
          <el-button
            type="primary"
            @click="handleExport"
            :loading="buttonLoading"
            >导出</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import http, { server, getData, delApiData, getApiData, postApiData, patchApiData } from '../../http'
import saveFile from '@/utils/saveFile'

export default {
  props: {
    visible: {//展示标志
      type: Boolean,
      default: false
    },
    value: {//数据
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      formData: {//任务表单
        box_id: undefined,//盒子id列表
        start_time: undefined,//开始时间
        end_time: undefined,//结束时间
      },
      taskRules: {//任务表单验证
        box_id: [
          {
            required: true,
            message: '请输入箱子id',
            trigger: 'blur'
          }
        ],
      }
    }
  },
  computed: {
    ...mapState({
    }),
    dialogVisible: {
      get() {
        return this.visible
      },
      set() {
      }
    },
    taskInfo: {
      get() {
        return this.value
      },
      set() {
      }
    }
  },
  watch: {
  },
  created() {
  },
  methods: {
    handleExport() {
      //保存任务
      //表单验证后发起请求
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          this.buttonLoading = true
          let params = this.formData

          http
            .post(
              server + 'box_prize/export',
              { ...params, page: undefined },
              {
                responseType: 'arraybuffer'
              }
            )
            .then(res => {
              saveFile(res, {
                type:
                  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                name: '盒子信息.xlsx'
              })
            }).finally(() => {
              this.buttonLoading = false
            })
        }
      })
    },
    closeDialog() {
      //关闭弹窗
      this.$emit("close")
    }
  }

}
</script>
<style lang="less" scoped>
</style>